import axios from 'axios';

const BASE_URL = process.env.VUE_APP_API_URL || 'https://tequire.io/api/v1/'; // 'https://tequire.io/api/v1/';

export default (
    method,
    url,
    params,
    body,
    authorize,
    baseURL,
    image
) => templateFunctions => {
    url = baseURL ? baseURL + url : BASE_URL + url;

    let headers = {
        'Content-Type': image ? 'multipart/form' : 'application/json',
    };

    /* // Check if new access-token needs to be retrieved by refresh-token
    if (templateFunctions.shouldRefreshToken && templateFunctions.getAccessByRefresh) {
        const shouldRefresh = templateFunctions.shouldRefreshToken();
        if(shouldRefresh) {
            templateFunctions.getAccessByRefresh();
        }
    } */

    if (authorize) {
        if (templateFunctions.getAuthToken) {
            const token = templateFunctions.getAuthToken();
            if (token) {
                headers.Authorization = `Bearer ${token}`;
            }
        } else {
            throw Error(
                'templateFunctions is missing auth token getter, use: RestX.registerTemplateFunctions({ getAuthToken: () => String })'
            );
        }
    }

    const options = {
        method,
        url,
        headers,
    };

    if (method !== 'GET') {
        options.data = body;
    }

    return axios(options);
};
